import axios from "axios";
import {
  ConsentManagementService_URL,
  CompanyManagementService_URL,
} from "../Url";
import HashMap from "hashmap";
import { logoutFlagUpdateData } from "../auth/actions";

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

///////GET CONSENT PURPOSE

export const GetConsentPurposeDetailsActions = {
  FETCH_CONSENT_PURPOSE_DETAILS: "FETCH_CONSENT_PURPOSE_DETAILS",
  FETCH_CONSENT_PURPOSE_DETAILS_STATUS: "FETCH_CONSENT_PURPOSE_DETAILS_STATUS",
  FETCH_CONSENT_PURPOSE_DETAILS_FULFILLED:
    "FETCH_CONSENT_PURPOSE_DETAILS_FULFILLED",
  FETCH_CONSENT_PURPOSE_DETAILS_REJECTED:
    "FETCH_CONSENT_PURPOSE_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getConsentPurposeDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      data: { emailId: params.emailID },
      url: `${ConsentManagementService_URL}/Apc_View/Amc_52/getAllConsentPurposesUnderConsentPointOfConsentedUser`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        // dispatch(getConsentPurposeDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getConsentPurposeDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getConsentPurposeDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getConsentPurposeDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getConsentPurposeDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getConsentPurposeDetailsError(err));
              break;
            case 500:
              dispatch(getConsentPurposeDetailsError("Server Error"));
              break;
            default:
              dispatch(getConsentPurposeDetailsError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
          dispatch(logoutFlagUpdateData());
        }
      });
}

export function getConsentPurposeDetailsRequest() {
  return {
    type: GetConsentPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS,
    isPosting: true,
  };
}
export function getConsentPurposeDetailsError(error) {
  return {
    type: GetConsentPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS_REJECTED,
    payload: error,
  };
}

export function getConsentPurposeDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetConsentPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getConsentPurposeDetailsStatus() {
  return (dispatch) => dispatch(getConsentPurposeDetailsStatusRequest());
}
export function getConsentPurposeDetailsStatusRequest() {
  return {
    type: GetConsentPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS_STATUS,
  };
}

///////GET CONSENT Point PURPOSE

export const GetConsentPointPurposeDetailsActions = {
  FETCH_CONSENT_POINT_PURPOSE_DETAILS: "FETCH_CONSENT_POINT_PURPOSE_DETAILS",
  FETCH_CONSENT_POINT_PURPOSE_DETAILS_STATUS:
    "FETCH_CONSENT_POINT_PURPOSE_DETAILS_STATUS",
  FETCH_CONSENT_POINT_PURPOSE_DETAILS_FULFILLED:
    "FETCH_CONSENT_POINT_PURPOSE_DETAILS_FULFILLED",
  FETCH_CONSENT_POINT_PURPOSE_DETAILS_REJECTED:
    "FETCH_CONSENT_POINT_PURPOSE_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getConsentPointPurposeDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      data: { emailId: params.emailID },
      url: `${ConsentManagementService_URL}/Apc_View/Amc_52/getAllConsentPointsUnderConsentPurposeOfConsentedUser`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getConsentPointPurposeDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getConsentPointPurposeDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getConsentPointPurposeDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getConsentPointPurposeDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getConsentPointPurposeDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getConsentPointPurposeDetailsError(err));
              break;
            case 500:
              dispatch(getConsentPointPurposeDetailsError("Server Error"));
              break;
            default:
              dispatch(getConsentPointPurposeDetailsError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
          // dispatch(logoutFlagUpdateData());
          dispatch(logoutFlagUpdateData());
        }
      });
}

export function getConsentPointPurposeDetailsRequest() {
  return {
    type: GetConsentPointPurposeDetailsActions.FETCH_CONSENT_POINT_PURPOSE_DETAILS,
    isPosting: true,
  };
}
export function getConsentPointPurposeDetailsError(error) {
  return {
    type: GetConsentPointPurposeDetailsActions.FETCH_CONSENT_POINT_PURPOSE_DETAILS_REJECTED,
    payload: error,
  };
}

export function getConsentPointPurposeDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetConsentPointPurposeDetailsActions.FETCH_CONSENT_POINT_PURPOSE_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getConsentPointPurposeDetailsStatus() {
  return (dispatch) => dispatch(getConsentPurposeDetailsStatusRequest());
}
export function getConsentPointPurposeDetailsStatusRequest() {
  return {
    type: GetConsentPointPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS_STATUS,
  };
}

// unSubscribe or Renew API actions

///////GET CONSENT Point PURPOSE

export const ConsentPointUnSubscribeOrRenewActions = {
  SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS:
    "SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS",
  SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_STATUS:
    "SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_STATUS",
  SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_FULFILLED:
    "SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_FULFILLED",
  SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_REJECTED:
    "SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function ConsentPointUnSubscribeOrRenewDetails(params) {
  const actionEndpoints = {
    renew: "Apc_Persist/Amc_90/renewConsentPurposeOfInteractionV2",
    unsubscribe: "Apc_Persist/Amc_90/unSubscribeConsentPurposeOfInteractionV2",
    subscribe: "Apc_Persist/Amc_90/subscribeConsentPurposeOfInteractionV2",
  };

  const finalurl = actionEndpoints[params.action];
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url: `${ConsentManagementService_URL}/${finalurl}?entryId=${params.entryId}&purposeId=${params.purposeId}`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(setConsentPointUnSubscribeOrRenewDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(setConsentPointUnSubscribeOrRenewDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(setConsentPointUnSubscribeOrRenewDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(setConsentPointUnSubscribeOrRenewDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(setConsentPointUnSubscribeOrRenewDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(setConsentPointUnSubscribeOrRenewDetailsError(err));
              break;
            case 500:
              dispatch(
                setConsentPointUnSubscribeOrRenewDetailsError("Server Error")
              );
              break;
            default:
              dispatch(
                setConsentPointUnSubscribeOrRenewDetailsError("Unknown Error")
              );
              break;
          }
        } else {
          // dispatch(logout());
          // dispatch(logoutFlagUpdateData());
          dispatch(logoutFlagUpdateData());
        }
      });
}

export function setConsentPointUnSubscribeOrRenewDetailsRequest() {
  return {
    type: ConsentPointUnSubscribeOrRenewActions.SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS,
    isPosting: true,
  };
}
export function setConsentPointUnSubscribeOrRenewDetailsError(error) {
  return {
    type: ConsentPointUnSubscribeOrRenewActions.SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_REJECTED,
    payload: error,
  };
}

export function setConsentPointUnSubscribeOrRenewDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: ConsentPointUnSubscribeOrRenewActions.SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function setConsentPointUnSubscribeOrRenewDetailsStatus() {
  return (dispatch) =>
    dispatch(setConsentPointUnSubscribeOrRenewDetailsRequest());
}
export function setConsentPointUnSubscribeOrRenewDetailsStatusRequest() {
  return {
    type: ConsentPointUnSubscribeOrRenewActions.SET_UNSUBSCRIBE_OR_RENEW_CONSENT_PURPOSE_DETAILS_STATUS,
  };
}

export const GetCompanyDetailsActions = {
  FETCH_COMPANY_DETAILS: "FETCH_COMPANY_DETAILS",
  FETCH_COMPANY_DETAILS_STATUS: "FETCH_COMPANY_DETAILS_STATUS",
  FETCH_COMPANY_DETAILS_FULFILLED: "FETCH_COMPANY_DETAILS_FULFILLED",
  FETCH_COMPANY_DETAILS_REJECTED: "FETCH_COMPANY_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getCompanyDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url:
        `${CompanyManagementService_URL}/Apc_View/Amc_43/getLogoByCompanyId?id=` +
        params.id,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getCompanyDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getCompanyDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getCompanyDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getCompanyDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getCompanyDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getCompanyDetailsError(err));
              break;
            case 500:
              dispatch(getCompanyDetailsError("Server Error"));
              break;
            default:
              dispatch(getCompanyDetailsError("Unknown Error"));
              break;
          }
        } else {
          // //dispatch(logout());
          // dispatch(clearLogoutData());
        }
      });
}

export function getCompanyDetailsRequest() {
  return {
    type: GetCompanyDetailsActions.FETCH_COMPANY_DETAILS,
    isPosting: true,
  };
}
export function getCompanyDetailsError(error) {
  return {
    type: GetCompanyDetailsActions.FETCH_COMPANY_DETAILS_REJECTED,
    payload: error,
  };
}

export function getCompanyDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetCompanyDetailsActions.FETCH_COMPANY_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getCompanyDetailsStatus() {
  return (dispatch) => dispatch(getCompanyDetailsStatusRequest());
}
export function getCompanyDetailsStatusRequest() {
  return {
    type: GetCompanyDetailsActions.FETCH_COMPANY_DETAILS_STATUS,
  };
}

export function setDetailsError() {
  return (dispatch) => dispatch(getCompanyDetailsErrorRequest());
}
export function getCompanyDetailsErrorRequest() {
  return {
    type: GetCompanyDetailsActions.SET_EDIT_ERROR,
  };
}

export function listingConsents(companyId, email, token, entityId) {
  return () =>
    axios({
      method: "post",
      url: `${ConsentManagementService_URL}/Apc_View/Amc_52/listingConsents?companyId=${companyId}&email=${encodeURIComponent(email)}${entityId ? `&entityId=${entityId}` : ""}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        start: 0,
        length: 10,
        status: true,
        defaultSort: {
          sortOrder: "desc",
          sortField: "id",
        },
      },
    })
      .then((response) => response)
      .catch((err) => { throw err; });
}

export function refreshDpInfo(email, token, entityId) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${ConsentManagementService_URL}/Apc_View/Amc_52/getDataPrincipalInfoByEmail?email=${encodeURIComponent(email)}${entityId ? `&entityId=${entityId}` : ""}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: "",
    })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch({ type: "UPDATE_DP_INFO", payload: response.data });
        }
        return response;
      })
      .catch((err) => { throw err; });
}

export function getConsentHistory(companyId, consentDataPrincipalId, consentPurposeId, token, entityId) {
  return () =>
    axios({
      method: "post",
      url: `${ConsentManagementService_URL}/Apc_View/Amc_52/get/ConsentHistory/ByDpIdAndPurposeId?companyId=${companyId}&consentDataPrincipalId=${consentDataPrincipalId}&consentPurposeId=${consentPurposeId}${entityId ? `&entityId=${entityId}` : ""}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: "",
    })
      .then((response) => response)
      .catch((err) => { throw err; });
}
